import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export const SelectedPhaseItem = ({ id, name, onRemove }) => {
  const { darkMode } = useContext(ThemeContext);

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleClick = (e) => {
    e.stopPropagation();
    onRemove?.(id); // <-- Use this instead of alert for real removal
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        width: "100%",
        px: { xs: 2, sm: "20px", md: 2, lg: "20px" },
        py: "12px",
        borderRadius: "5px",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: darkMode
          ? getColors.thumbnailBorderDark
          : getColors.thumbnailBorderLight,
        background: darkMode
          ? getColors.thumbnnailBgDark
          : getColors.thumbnnailBgLight,
        "&:hover": {
          borderColor: darkMode
            ? getColors.thumbnailTextDark
            : getColors.thumbnailTextLight,
        },
      }}
    >
      <Box
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        sx={{
          cursor: "pointer",
          width: "100%",
          height: "100%",
          display: "flex", // Add this
          alignItems: "center", // Vertical centering
        }}
      >
        <Typography
          sx={{
            fontSize: "22px",
            fontWeight: 500,
            color: darkMode
              ? getColors.drawerTextDark
              : getColors.thumbnailTextLight,
            userSelect: "none", // <--- Add this line
          }}
        >
          {name}
        </Typography>
      </Box>

      <Box
        display={"flex"}
        justifyContent={"flex-end"}
        width="max-content"
        sx={{
          borderRadius: "50%",
          padding: { xs: 2, sm: "20px", md: 2, lg: "20px" },
          color: "#FF3D3D",
          bgcolor: "#FFE8E8",
          alignItems: "center",
          "&:hover": {
            color: "red",
          },
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <DeleteOutlinedIcon />
      </Box>
    </Box>
  );
};
